import { t } from '../../i18n/index.ts'
import { appendBlocks } from '../dom.ts'
import { navigate } from '../router.ts'
import { isCapacitorNative } from '../../api/ZionServer.ts'
import { splashLogoHtml } from '../../assets/appIcon.ts'

export function renderAddToHomeScreen(root: HTMLElement): void {
  // App Capacitor già “installata” — salta guida PWA
  if (isCapacitorNative()) {
    navigate('home')
    return
  }
  root.innerHTML = ''
  appendBlocks(
    root,
    `
      <header class="splash compact">
        ${splashLogoHtml()}
        <p class="tagline">${t('add_home_title')}</p>
      </header>
      <section class="card">
        <h2>${t('add_home_guide_title')}</h2>
        <ol class="guide-steps">
          <li>${t('add_home_step1')}</li>
          <li>${t('add_home_step2')}</li>
          <li>${t('add_home_step3')}</li>
          <li>${t('add_home_step4')}</li>
        </ol>
        <p class="status muted small">${t('add_home_hint')}</p>
        <button type="button" id="btn-continue">${t('add_home_btn_continue')}</button>
        <button type="button" class="secondary" id="btn-skip">${t('add_home_btn_skip')}</button>
      </section>
    `,
  )

  root.querySelector('#btn-continue')!.addEventListener('click', () => navigate('home'))
  root.querySelector('#btn-skip')!.addEventListener('click', () => navigate('home'))
}
